export default () => window.BRAND || '<undefined>'
